/**
 * @param {import("../../types/accounts").Account} account
 */
export const isPersonalAccount = account => !!account && account.type === 'personal';

/**
 * @param {import("../../types/accounts").Account} account
 */
export const isTeamAccount = account => !!account && account.type === 'team';
